// 상수 JSON 파일들을 불러옵니다 (src/constants/json/*.json)
import patentRaw from "./json/patent.json";
import historyRaw from "./json/history.json";
import clientsRaw from "./json/clients.json";

// 특허 항목 타입: 화면에 표시하기 위해 정규화한 구조입니다
export interface PatentItem {
  title: string; // 특허 제목
  number: string; // 등록번호 (원문에 없으면 빈 문자열)
  date: string; // 연도 + (있다면) 월/일 정보
}

// 연혁 페이지에서 사용하는 항목 타입들
export interface HistoryItem {
  month: string; // 예: "10월"
  text: string[]; // 해당 월의 항목 문장들
}

export interface YearData {
  year: string; // 예: "2022년"
  list: HistoryItem[]; // 해당 연도의 항목들
}

export interface HistoryCategory {
  category: string; // 탭 id (예: "tab1")
  years: YearData[]; // 연도 그룹들
}

// 클라이언트(고객사) 타입
export interface ClientItem {
  name: string; // 회사명
  img: string; // 이미지 파일명
}

export interface ClientCategory {
  category: string; // 카테고리명 (예: "금융 분야")
  list: ClientItem[]; // 해당 카테고리의 고객사 리스트
}

// 특허 JSON(patentRaw)은 연도별 문자열 목록 형태로 되어 있어 화면 표시용으로 정규화합니다.
// 예: { year: '2014년', list: ['1월 23일 | 제목', ...] } -> [{ title, number, date }, ...]
export const patents: PatentItem[] = (patentRaw as Array<{ year: string; list: string[] }>).flatMap(
  entry =>
    entry.list.map(item => {
      const parts = item.split("|").map(s => s.trim());
      const datePart = parts.length > 1 ? parts[0] : "";
      const titlePart = parts.length > 1 ? parts[1] : parts[0];
      return {
        title: titlePart,
        number: "",
        date: `${entry.year}${datePart ? " " + datePart : ""}`.trim(),
      };
    })
);

// 연혁(history)과 고객사(clients) JSON은 이미 구조화되어 있으므로 타입 단언으로 바로 사용합니다.
export const history: HistoryCategory[] = historyRaw as HistoryCategory[];
export const clients: ClientCategory[] = clientsRaw as ClientCategory[];

// 편리한 기본 export
export default {
  patents,
  history,
  clients,
};
